import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()

export class LocalStorageHelpers {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  get(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
  }

  set(key: string, value: any) {
    if (isPlatformBrowser(this.platformId)) {
       return localStorage.setItem(key, value);
    }
  }

  remove(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.removeItem(key);
    }
  }

}
